import React, { useState, useEffect } from "react";
import DatePicker from 'react-datepicker';
import { useLocation } from 'react-router-dom';
import axios from "axios";
import { Link } from 'react-router-dom';
import './QcTPDSWhATRUpdate.css'
import jsPDF from "jspdf";
import "jspdf-autotable";
import Select from 'react-select';
import { format, set } from 'date-fns';
import pomisHeaderImage from './pomisHeader.jpeg';
import pds from './pds.PNG';
import ExcelJS from 'exceljs';
const customStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: "4px",
        padding: "2px",

    }),
    dropdownIndicator: (provided) => ({
        ...provided,

        cursor: "pointer", // Change cursor to indicate it's clickable
    }),
    indicatorSeparator: () => ({
        display: "none", // Hide the default separator

    }),
};
const QcTPDSWhATRUpdate = () => {
    const [fpsOptions, setFpsOptions] = useState([]); // Store the fetched FPS options
    const [districtUid, setDistrictUid] = useState(''); // Store districtUid for reports
    const [isDistrictSelected, setIsDistrictSelected] = useState(false); // To track if the district is already selected
    const [isSubDivisionSelected, setIsSubDivisionSelected] = useState(false); // To track if the district is already selected
    const [isBlockSelected, setIsBlockSelected] = useState(false);
    const [subDivisionUid, setSubDivisionUid] = useState(''); // Store subdistrictUid for reports
    const [blockUid, setBlockUid] = useState('');
    const [panchayatUidP, setpanchayatUidP] = useState('');
    const [districtId, setDistrictId] = useState("");
    const [subDivisionId, setSubDivisionId] = useState('');
    const [blockId, setBlockId] = useState('');
    const [districts, setDistricts] = useState([]);
    const [subDivisions, setSubDivisions] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [panchayatId, setPanchayatId] = useState("");
    const [panchayats, setPanchayats] = useState([]);
    const [godownId, setGodownId] = useState("");
    const [godownUniqueId, setGodownUniqueId] = useState("");
    const [fpshops, setFPShops] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [startDateP, setStartDate] = useState(null);
    const [endDateP, setEndDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [showEndCalendar, setShowEndCalendar] = useState(false);
    const [error, setError] = useState(null);  // Define setError here
    const [isOpen, setIsOpen] = useState(false);
    const [reportData, setReportData] = useState([]);  // State to hold report data
    const [showDownloadButton, setShowDownloadButton] = useState(false);  // Control visibility of DOWNLOAD PDF button
    const [showTable, setShowTable] = useState(false);
    const [stockData, setStockData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isModified, setIsModified] = useState(false);
    // Get the current date and reset time to midnight to avoid time-based issues
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Reset time to midnight
    const [finalErrors, setFinalErrors] = useState({});
    const currentYear = currentDate.getFullYear();
    const minStartDate = new Date(2025, 0, 1); // January 1st of current year
    const location = useLocation();
    const godownIdFromQuery = new URLSearchParams(location.search).get('godownId'); // Get fpsId from query params
    const [selectedRows, setSelectedRows] = React.useState(new Set());
    // Highlight the row corresponding to the fpsId
    const getRowClass = (godownId) => {
        return godownId === godownIdFromQuery ? 'highlight-row' : '';
    };
    //console.log('7afc6a17404f3b863333e277746c2f1764efa956bbcd6cb2480e276dc7d7e7a3cae7882f9f4414164e9e3b054b14272522b665c7ab8d84c1a41545acdb551446e16d2e19a8d266d032601d2b4a922ed1c0f928bc72967f21f73236fea64230a8bf3832a7765f817231f96721a400a57fd765a4a1d286c6b979183ba68e2a5fa5', token); // Debugging step: Ensure the token is correctly set
    const handleViewReportClick = (godownId, startTime, username) => {
        // Save fpsId and date to localStorage or sessionStorage
        localStorage.setItem('godownId', godownId);
        localStorage.setItem('startTime', startTime);
        localStorage.setItem('username', username); // Make sure username is set here
    };
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const [userInfo, setUserInfo] = useState({
        // displayName: '',
        // empId: ''
        fullName: '',
        employeeId: '',
        id: '',
        username: '',
    });
    const [sortedStockData, setSortedStockData] = useState([]);

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        const loginTime = localStorage.getItem('loginTime');

        if (userData) {
            // Extract the first name from fullName (only the first word)
            const firstName = userData.fullName.split(' ')[0];

            // Set the state with firstName and employeeId
            setUserInfo({
                fullName: firstName,  // Only first name is considered
                employeeId: userData.employeeId,
                id: userData.id,
                username: userData.username,
            });
            setIsLoggedIn(true);
            // setLastLoginDateTime(`Last Login: ${format(new Date(loginTime), 'dd-MM-yyyy | hh:mm:ss a')}`);
        } else {
            setIsLoggedIn(false);
        }
    }, []);
    // Handle Start Date Change
    const handleStartDateChange = (date) => {
        setStartDate(date); // Set the selected start date
        setEndDate(''); // Clear the end date when start date changes
        setShowCalendar(false); // Hide the start date calendar after selection
        setShowEndCalendar(false); // Hide the end date calendar
    };

    // Handle End Date Change
    const handleEndDateChange = (date) => {
        setEndDate(date); // Set the selected end date
        setShowEndCalendar(false); // Hide the end date calendar
    };

    // Show the End Date calendar
    const handleEndDateClick = () => {
        // Only show the calendar for endDateP if startDateP is selected
        if (startDateP) {
            setShowEndCalendar(true);
        }
    };
    // Token you provided (for testing purposes)
    // const token = '7afc6a17404f3b863333e277746c2f1764efa956bbcd6cb2480e276dc7d7e7a3cae7882f9f4414164e9e3b054b14272522b665c7ab8d84c1a41545acdb551446e16d2e19a8d266d032601d2b4a922ed1c0f928bc72967f21f73236fea64230a8bf3832a7765f817231f96721a400a57fd765a4a1d286c6b979183ba68e2a5fa5';
    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;
    const godownUrl = `${process.env.REACT_APP_GODOWN_API_URL}/api`;


    useEffect(() => {
        if (token) {

            axios
                .get(`${baseUrl}/districts?pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },

                })
                .then((response) => {
                    if (response.data && response.data.data && Array.isArray(response.data.data)) {

                        setDistricts(response.data.data);
                        const updatedDistricts = [
                            { district: 'All', districtName: 'All Districts', districtUid: null }, // 'All' option
                            ...response.data.data
                        ];

                        setDistricts(updatedDistricts); // Set the updated districts with 'All'
                    } else {
                        setError("Invalid response format");
                    }


                })
                .catch((error) => {
                    setError("Error fetching districts");
                    console.error("Error fetching districts:", error);
                });
        } else {
            setError("No token found. Please log in.");
        }
    }, [token]);
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        if (userData) {
            // Extract districtUid from the userData
            const userDistrictUid = userData.districtUid;

            // Set the districtId based on districtUid from the login payload
            const selectedDistrict = districts.find(dist => dist.districtUid === userDistrictUid);
            if (selectedDistrict) {
                setDistrictId(selectedDistrict.id); // Set districtId for the selected district
                setDistrictUid(selectedDistrict.districtUid); // Set districtUid for the report generation
                setIsDistrictSelected(true); // Set flag to indicate the district is selected
            }
        }
    }, [districts]);
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        if (userData) {
            // Extract districtUid from the userData

            const userSubDivisionUid = userData.subDivisionUid;
            // Set the districtId based on districtUid from the login payload
            const selectedSubDivision = subDivisions.find(sub => sub.subDivisionUid === userSubDivisionUid);
            if (selectedSubDivision) {
                setSubDivisionId(selectedSubDivision.id); // Set districtId for the selected district
                setSubDivisionUid(selectedSubDivision.subDivisionUid); // Set districtUid for the report generation
                setIsSubDivisionSelected(true); // Set flag to indicate the district is selected
            }
        }
    }, [subDivisions]);
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        if (userData) {
            // Extract districtUid from the userData

            const userBlockUid = userData.blockUid;
            // Set the districtId based on districtUid from the login payload
            const selectedBlock = blocks.find(b => b.blockUid === userBlockUid);
            if (selectedBlock) {
                setBlockId(selectedBlock.id); // Set districtId for the selected district
                setBlockUid(selectedBlock.blockUid); // Set districtUid for the report generation
                setIsBlockSelected(true); // Set flag to indicate the district is selected
            }
        }
    }, [blocks]);
    const fetchSubDivisions = async (districtId) => {
        if (districtId) {
            try {
                const response = await axios.get(`${baseUrl}/sub-divisions?filters[district][id][$eq]=${districtId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setSubDivisions(response.data.data || []);
            } catch (error) {
                setError("Error fetching sub-divisions");
            }
        } else {
            setSubDivisions([]);
        }
    };

    useEffect(() => {
        if (districtId) {
            fetchSubDivisions(districtId);
        }
    }, [districtId]); // Re-fetch subdivisions when districtId changes

    useEffect(() => {
        if (subDivisionId) {
            fetchBlocks(subDivisionId);
        }
    }, [subDivisionId]); // Re-fetch subdivisions when districtId changes
    useEffect(() => {
        if (blockId) {
            fetchPanchayats(blockId);
        }
    }, [blockId]);

    const fetchBlocks = async (subDivisionId) => {
        if (subDivisionId) {
            try {
                const response = await axios.get(`${baseUrl}/blocks?filters[subDivision][id][$eq]=${subDivisionId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setBlocks(response.data.data || []);
            } catch (error) {
                setError("Error fetching blocks");
            }
        } else {
            setBlocks([]);
        }
    };

    const fetchPanchayats = async (blockId) => {
        if (blockId) {
            try {
                const response = await axios.get(`${baseUrl}/panchayats?filters[block][id][$eq]=${blockId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setPanchayats(response.data.data || []);
            } catch (error) {
                setError("Error fetching panchayats");
            }
        } else {
            setPanchayats([]);
        }
    };

    const fetchGodownOptions = async () => {
        setIsLoading(true); // Show loading indicator

        // Construct request payload
        const requestData = {};

        if (districtUid) {
            requestData.district = districtUid;
        }
        if (subDivisionUid) {
            requestData.subDivision = subDivisionUid;
        }
        if (blockUid) {
            requestData.block = blockUid;
        }
        if (panchayatUidP) {
            requestData.panchayat = panchayatUidP;
        }
        requestData.surveyType = "2";
        try {
            const response = await axios.post(`${godownUrl}/get-godown-by-filters`, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.data && response.data.data) {
                setFpsOptions(response.data.data); // Set the fetched FPS options
            } else {
                setFpsOptions([]);
                setError("No FPS data found for the selected filters.");
            }
        } catch (error) {
            setError("Error fetching FPS options.");
            console.error('Error fetching FPS options:', error);
        } finally {
            setIsLoading(false); // Hide loading indicator
        }
    };

    useEffect(() => {
        // Fetch FPS options whenever the filters change
        if (districtUid || subDivisionUid || blockUid || panchayatUidP) {
            fetchGodownOptions();
        }
    }, [districtUid, subDivisionUid, blockUid, panchayatUidP]);

    const handleFpsSelection = (selectedFpsId) => {
        setGodownId(selectedFpsId); // Store the selected FPS ID
    };



    const handleDistrictChange = (selectedOption) => {
        const selectedDistrictId = selectedOption ? selectedOption.value : '';  // districtId for filtering
        const selectedDistrictUid = selectedOption ? selectedOption.districtUid : '';  // districtUid for reports
        const selectedDivisionName = selectedOption ? selectedOption.label : "";
        console.log('name of dis', selectedDivisionName);
        console.log('Selected District ID (for filtering):', selectedDistrictId);  // for filtering
        console.log('Selected District UID (for report generation):', selectedDistrictUid);  // for report generation

        // Set both districtId (for filtering) and districtUid (for report generation)
        setDistrictId(selectedDistrictId);  // For filtering
        setDistrictUid(selectedDistrictUid);  // For report generation
        setSubDivisionUid('');  // Clear subDivisionUid
        setpanchayatUidP('');  // Clear panchayatUidP
        setBlockUid('');
        setGodownUniqueId('')
        // Reset other state
        setSubDivisionId('');
        setBlockId('');

        setGodownId('');

        setFPShops([]);
        setPanchayats([]);
        setBlocks([]);
        setShowTable(false);

        // Fetch subdivisions based on districtId (for filtering)
        fetchSubDivisions(selectedDistrictId);

    };

    const handleGodownId = (selectedOption) => {
        const selectedGodownId = selectedOption ? selectedOption.value : '';
        const selectedGodownUniqueId = selectedOption ? selectedOption.label : '';

        console.log('Selected FPS:', selectedGodownId);
        console.log('unique normal ', selectedGodownUniqueId)
        setGodownId(selectedGodownId);  // Save the selected FPS ID
        setGodownUniqueId(selectedGodownUniqueId);  // Save the selected FPS Unique ID
        //setGodownUniqueId('');
        // setFpsId('');  
        setShowTable(false);  // Show the table after FPS ID is selected
    };


    // Function to clear all data (reset state)
    const handleClear = () => {
        setGodownId('');
        setDistrictUid('');
        setBlockUid('');
        setpanchayatUidP('');
        setSubDivisionUid('');
        // setDistrictUid('');
        setDistrictId('');
        setSubDivisionId('');
        setBlockId('');
        setPanchayatId('');
        setStartDate('');
        setEndDate('');
        // setFpsId('');
        setFPShops('');
        setShowDownloadButton(false);
        setShowTable(false);
    };
    const handleGenerateReport = () => {
        setIsLoading(true);
        setShowTable(true);
        // Case 1: Ensure start date is before end date (basic validation)
        if (startDateP && endDateP && startDateP > endDateP) {
            setError("Start date cannot be later than end date.");
            alert("Start date cannot be later than end date.");
            return;
        }


        setStockData([]);  // Clear previous stock data

        // Prepare request data
        const requestData = {};

        if (startDateP) {
            requestData.startDate = formatDate(startDateP);
        }

        if (endDateP) {
            requestData.endDate = formatDate(endDateP);
        }

        if (districtUid) {
            requestData.districtUid = districtUid;
            requestData.surveyType = "2";
        } else if (!districtUid && !godownId && !godownUniqueId) {
            // If no fpsId and no districtUid, set default as "All"
            requestData.districtUid = "All";
            requestData.surveyType = "2";
        }

        if (subDivisionUid) {
            requestData.subDivisionUid = subDivisionUid;
        }

        if (blockUid) {
            requestData.blockUid = blockUid;
        }

        // if (panchayatUidPP) {
        //     requestData.panchayatUidP = panchayatUidPP;
        // }

        if (panchayatUidP) {
            requestData.panchayatUid = panchayatUidP;
        }
        if (godownUniqueId) {
            requestData.godownId = godownUniqueId;  // Use godownUniqueId if it's available
        } else if (godownId) {
            requestData.godownId = godownId;  // Otherwise, use fpsId
        }


        console.log(requestData);  // Log the request data for debugging

        // Make the POST request to fetch the report
        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/reports/godown-action-taken-report`, requestData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',  // Ensure content type is set
                },
            })
            .then((response) => {
                setIsLoading(false);  // Stop loading

                if (response.data && response.data.length > 0) {
                    const allowedActions = ["qc", "agm", "agm-qc", "other"];

                    const filteredData = response.data.filter((entry) => {
                        return (
                            allowedActions.includes(entry.actionInitiated) &&
                            entry.actionStatus === "open"
                        );
                    });

                    setStockData(filteredData);
                    setShowDownloadButton(filteredData.length > 0);
                    setShowTable(true);
                } else {
                    setStockData([]);
                    setError("No data available for the selected filters.");
                    setShowDownloadButton(false);
                    setShowTable(true);
                }
            })
            .catch((error) => {
                setIsLoading(false);  // Stop loading
                setError("Error fetching report.");
                console.error('Error fetching report:', error);
                setShowDownloadButton(false);  // Hide download button if there was an error
                setShowTable(true);  // Show the table even if there's an error
            });
    };



    const sortData = (data) => {
        return data.sort((a, b) => {
            const districtA = a.districtName || '';
            const districtB = b.districtName || '';
            const subDivisionA = a.subDivisionName || '';
            const subDivisionB = b.subDivisionName || '';
            const blockA = a.blockName || '';
            const blockB = b.blockName || '';
            const panchayatA = a.panchayatName || '';
            const panchayatB = b.panchayatName || '';

            // Sorting order: first district, then sub-division, then block, and finally panchayat
            if (districtA < districtB) return -1;
            if (districtA > districtB) return 1;
            if (subDivisionA < subDivisionB) return -1;
            if (subDivisionA > subDivisionB) return 1;
            if (blockA < blockB) return -1;
            if (blockA > blockB) return 1;
            if (panchayatA < panchayatB) return -1;
            if (panchayatA > panchayatB) return 1;
            return 0;
        });
    };
    //const sortedStockData = sortData(stockData);

    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    const formatFullName = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text
                .split(' ') // Split the string by spaces into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
                .join(' '); // Join the words back into a single string with spaces
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    // Controlled dropdown open/close
    const toggleDropdown = () => {
        setIsOpen((prevState) => !prevState);
    };

    const formatDate = (date) => {
        if (!date) return null;
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const handleGodownIdChange = (selectedOption) => {
        const selectedFpsId = selectedOption ? selectedOption.value : '';
        setGodownId(selectedFpsId);  // Set FPS ID state
    };

    //   const toggleDropdown = () => {
    //     setIsOpen(!isOpen);  // Toggle dropdown visibility
    //   };
    // const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const username = queryParams.get('username');
    const startDate = queryParams.get('startDate');
    const endDate = queryParams.get('endDate');
    const panchayatUid = queryParams.get('panchayatUid'); // Fixed typo here

    useEffect(() => {
        console.log("Query Params:", queryParams.toString());
        console.log("Username:", username);
        console.log("Panchayat UID:", panchayatUid);
        console.log("Start Date:", startDate);
        console.log("End Date:", endDate);

        if (username && startDate && endDate) {
            const fetchInspectionData = async () => {
                setIsLoading(true);
                try {
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/reports/godown-inspection`,
                        { username, panchayatUid, startDate, endDate },
                        { headers: { Authorization: `Bearer ${token}` } }
                    );

                    console.log('Fetched data:', response.data);
                    setStockData(response.data);
                    setShowTable(true);
                } catch (error) {
                    console.error('Error fetching inspection data:', error);
                } finally {
                    setIsLoading(false);
                }
            };

            fetchInspectionData();
        } else {
            setIsLoading(false);
        }
    }, [username, startDate, endDate, token, panchayatUid]);
    //console.log('sortedStockData:', sortedStockData);
    // const handleDropdownChange = (godownId, field, value) => {
    //     setStockData(prev => {
    //         const newData = [...prev];
    //         const index = newData.findIndex(entry => entry.godownId === godownId);
    //         if (index !== -1) {
    //             newData[index] = { ...newData[index], [field]: value };
    //         }
    //         return newData;
    //     });
    // };
    const handleDropdownChange = (godownId, field, value) => {
        setStockData(prev => {
            const newData = [...prev];
            const index = newData.findIndex(entry => entry.godownId === godownId);
            if (index !== -1) {
                newData[index] = { ...newData[index], [field]: value };
            }
            return newData;
        });
        setIsModified(true);
    };

    const capitalizeWords = (str) => {
        if (!str || typeof str !== "string") return "";
        return str
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };
    const handleSubmit = () => {
        const selectedIndexes = Array.from(selectedRows);

        if (selectedIndexes.length === 0) {
            alert("Please select at least one row before submitting.");
            return;
        }

        const payload = selectedIndexes
            .map(index => sortedStockData[index])
            .filter(entry => entry && entry.actionType && entry.actionType.trim()) // ✅ safe check here
            .map(entry => {
                let status = "";
                let finalAction = null;
                const action = (entry.actionType || "").trim().toLowerCase();

                if (action === "notice" || action === "fir") {
                    status = "open";
                } else if (action === "revoke" || action === "cancel license") {
                    status = "close";
                    finalAction = action;
                }

                return {
                    fairPriceShop: entry.fairPriceShop,
                    poimsUser: userInfo.id,
                    officerUserName: entry.officerUserName,
                    survey: entry.surveryId,
                    actionInitiated: entry.actionType || "",
                    actionStatus: status,
                    remarks: entry.remarksAction || "",
                    ...(finalAction && { finalAction }),
                };
            });

        if (payload.length === 0) {
            alert("No valid rows to submit.");
            return;
        }

        const finalPayload = { data: payload };

        setIsLoading(true);
        axios.post(`${baseUrl}/beneficiary-feedback-actions/create-manys`, finalPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then(() => {
                alert("Existing Stock Verification submitted successfully!");

                // Clear selectedRows and reset action data from submitted rows
                const newData = [...sortedStockData];
                selectedIndexes.forEach(index => {
                    if (newData[index]) {
                        newData[index].actionType = "";
                        newData[index].remarksAction = "";
                    }
                });

                setSortedStockData(newData);
                setSelectedRows(new Set());
                // Refresh the table data
                handleGenerateReport();
            })

            .catch((error) => {
                console.error("❌ Error submitting:", error);
                alert("Failed to submit stock verification!");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
    const handleUpdate = () => {
        setFinalErrors({}); // clear old errors

        const newErrors = {};

        // Validate all “other” actions
        stockData.forEach((entry, index) => {
            if (
                entry.actionTaken === "other" &&
                (!entry.finalRemarks || entry.finalRemarks.trim() === "")
            ) {
                newErrors[index] =
                    "Final remarks are required when 'Any other action' is selected.";
            }
        });

        // If errors exist, stop here and show inline messages
        if (Object.keys(newErrors).length > 0) {
            setFinalErrors(newErrors);
            return;
        }

        const payload = stockData
            .filter((entry) =>
                ["revoke", "agm-suspended", "qc-suspended", "agm-qc-suspended", "salary-hold", "other"].includes(entry.actionTaken)
            )
            .map((entry) => ({
                poimsUser: userInfo.id,
                survey: entry.surveyId,
                finalAction: entry.actionTaken,
                actionStatus: "close",
                finalRemarks: entry.finalRemarks || null,
            }));

        // ✅ If no dropdown selected, show alert and return
        if (payload.length === 0) {
            alert("Please select a Final Decision.");
            return;
        }


        const finalPayload = { data: payload };

        console.log("✅ Payload to submit:", finalPayload);

        axios.post(
            `${baseUrl}/beneficiary-feedback-actions/by-surveys`,
            finalPayload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        )
            .then(() => {
                alert("Existing Stock Verification successfully!");
                handleGenerateReport();
                setIsModified(false);
                setFinalErrors({});
            })
            .catch((error) => {
                console.error("❌ Error submitting:", error);
                alert("Failed to submit stock verification!");
            });
    };

    const filteredData = sortedStockData.filter(
        entry =>
            (entry.actionInitiated === "notice" || entry.actionInitiated === "fir") &&
            entry.status !== "close"
    );

    const actionLabels = {
        agm: "Showcause issued to AGM",
        qc: "Showcause issued to QC",
        "agm-qc": "Showcause issued to AGM and QC",
        "other": "Any other action",
    };


    return (
        <div className="inspection-repo-QcTWheatUpd">
            {/* <div className="fpsstockdeviationname">
                    <p>FPS Stock Deviation Report</p>
                </div> */}

            <div className="inspection-repo-drop-QcTWheatUpd">
                <div className="inspection-card-head-QcTWheatUpd ">QC-TPDS Wheat ATR Updation Form</div>
                <div className='QcTWheatUpd-whole-div'>
                    <div className="QcTWheatUpd-main">
                        <div className="QcTWheatUpd-group">
                            <label htmlFor="district" >
                                <span className="asterisk">*</span>District
                            </label>
                            <Select
                                className="QcTWheatUpd-search-select"
                                id="district"
                                value={districts.find((dist) => dist.id === districtId) ? {
                                    value: districts.find((dist) => dist.id === districtId).id,  // districtId for filtering
                                    label: capitalizeFirstLetter(districts.find((dist) => dist.id === districtId).districtName)
                                } : null}
                                onChange={handleDistrictChange}  // Handle the selection change
                                options={districts
                                    .sort((a, b) => a.districtName.localeCompare(b.districtName))  // Sort by districtName alphabetically
                                    .map((dist) => ({
                                        value: dist.id,  // Use districtId here for filtering
                                        label: capitalizeFirstLetter(dist.districtName),  // Show districtName as label
                                        districtUid: dist.districtUid,  // Include districtUid for report generation
                                    }))
                                }
                                isDisabled={isDistrictSelected}
                                placeholder="Select a district"
                                isSearchable  // Enable search
                                styles={customStyles}  // Apply custom styles
                                required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}  // Trigger dropdown open
                                onMenuClose={toggleDropdown}  // Trigger dropdown close
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px" }}>
                                            <img
                                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                alt="Dropdown"
                                                style={{ width: "20px", height: "20px" }}
                                            />
                                        </div>
                                    ),
                                }}
                            />

                        </div>


                        <div className="QcTWheatUpd-group">
                            {/* <label htmlFor="fpsId">Godown ID</label>
                            {districtId || districtUid ? (
                                <Select
                                    className="QcTWheatUpd-search-select"
                                    id="fps"
                                    value={godownId ? {
                                        value: godownId,
                                        label: fpsOptions.find((fps) => fps.id === godownId)?.godownId  // Use fpsId for label
                                    } : null}
                                    onChange={handleGodownId}
                                    options={fpsOptions.sort((a, b) => a.godownId.localeCompare(b.godownId))
                                        .map((fps) => ({
                                            value: fps.id,
                                            label: fps.godownId,  // Display the fpsId as label
                                            godownUniqueId: fps.godownUniqueId,  // Include godownUniqueId for report generation
                                        }))}
                                    placeholder="Select Godown Shop"
                                    isSearchable
                                    styles={customStyles}
                                    required
                                    isOpen={isOpen}
                                    onMenuOpen={toggleDropdown}
                                    onMenuClose={toggleDropdown}
                                    components={{
                                        DropdownIndicator: () => (
                                            <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                                <img
                                                    src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                    alt="Dropdown"
                                                    style={{ width: '20px', height: '20px' }}
                                                />
                                            </div>
                                        ),
                                    }}
                                />
                            ) : (
                                <input className="QcTWheatUpd-search-select-1"
                                    type="text"
                                    placeholder="Enter Godown ID"
                                    value={godownId}
                                    onChange={(e) => setGodownId(e.target.value)}
                                    style={{ padding: '5px' }}
                                />
                            )} */}

                        </div>

                        <div className="QcTWheatUpd-group-2">
                            <div className="QcTWheatUpd-group-4">
                                <button className="inspection-button" onClick={handleClear}
                                    disabled={
                                        // Button is disabled if no districtId or fpsId is provided AND no startDateP and endDateP are provided
                                        !(godownId || (districtUid && startDateP && endDateP) || (districtUid === null && startDateP && endDateP))
                                    }
                                >CLEAR
                                </button>


                                <button
                                    className="inspection-button"
                                    onClick={handleGenerateReport}
                                    disabled={
                                        // Button is disabled if no districtId or fpsId is provided AND no startDateP and endDateP are provided
                                        !(godownId || (districtUid && startDateP && endDateP) || (districtUid === null && startDateP && endDateP))
                                    }  // Disable if any field is not selected
                                // disabled={!districtId }
                                >
                                    Fetch Data
                                </button>
                            </div>
                        </div>

                    </div>



                    <div className="QcTWheatUpd-block-3">
                        <div className="QcTWheatUpd-group-3">
                            <label htmlFor="startDateP" ><span className="asterisk">*</span>From Date</label>
                            <div className="dates-setting-stock-repo-QcTWheatUpd">
                                <input
                                    type="text"
                                    id="startDateP"
                                    className="godowninspection-input-repo"
                                    value={startDateP ? format(startDateP, 'dd-MM-yyyy') : ''}
                                    readOnly
                                    onClick={() => setShowCalendar(true)}
                                />
                                <div className="QcTWheatUpd-icon" onClick={() => setShowCalendar(true)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg>
                                </div>
                                {showCalendar && (
                                    <DatePicker
                                        selected={startDateP}
                                        onChange={handleStartDateChange}
                                        onClickOutside={() => setShowCalendar(false)}
                                        inline
                                        minDate={minStartDate} // From January 1st of current year
                                        maxDate={currentDate} // Today
                                    />
                                )}
                            </div>
                        </div>


                        <div className="QcTWheatUpd-group-3">
                            <label htmlFor="startDateP" ><span className="asterisk">*</span>To Date</label>
                            <div className="dates-setting-stock-repo-QcTWheatUpd">
                                <input
                                    type="text"
                                    id="startDateP"
                                    className="godowninspection-input-repo"
                                    value={endDateP ? format(endDateP, 'dd-MM-yyyy') : ''}
                                    readOnly
                                    onClick={() => setShowEndCalendar(true)}
                                    disabled={!startDateP}
                                />
                                <div className="QcTWheatUpd-icon" onClick={handleEndDateClick}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg>
                                </div>
                                {showEndCalendar && (
                                    <DatePicker
                                        selected={endDateP}

                                        onChange={handleEndDateChange}
                                        onClickOutside={() => setShowEndCalendar(false)}
                                        //  minDate={minEndDate} // Disable dates before startDateP
                                        inline
                                        minDate={startDateP} // End date can't be before the start date
                                        maxDate={currentDate} // End date can't be after today
                                    />
                                )}
                            </div>
                        </div>

                        <div className="QcTWheatUpd-group-3">

                            {/* Conditionally Render GET REPORT Button */}




                        </div>


                    </div>
                </div>
            </div>

            <div>
                <button className="existingStock-button" onClick={handleUpdate}
                    disabled={isLoading || stockData.length === 0 || !(godownId || (districtUid) || (districtUid === null))
                        || !isModified
                    }
                >
                    Update
                </button>
            </div>
            <div className="QcTWheatUpd-entry-repo">
                <table className="QcTWheatUpd-table-repo">
                    <thead>
                        <tr>
                            <th rowSpan="2">S.No</th>
                             <th rowSpan="2">District</th>
                            <th rowSpan="2">Godown Name</th>
                            <th rowSpan="2" >Inspection Officer Name</th>
                            <th rowSpan="2">Inspection Date </th>
                            <th rowSpan="2">Received From District Name</th>
                            <th rowSpan="2">Received From CMR Godown Name </th>
                            <th rowSpan="2">PACS Name</th>
                            <th rowSpan="2">Lot No</th>
                            <th rowSpan="2">Grain Type </th>
                            <th rowSpan="2">Stack No (in Numeric)</th>
                            <th rowSpan="2">Moisture(in %)</th>
                            <th rowSpan="2">Shrivelled & Broken Grains(in %)</th>
                            <th rowSpan="2">Damaged Grain(in %)</th>
                            <th rowSpan="2">Slightly Damaged Grain (in %)</th>
                            <th rowSpan="2">Weevilled Grains(in %)</th>
                            <th rowSpan="2">Foreign Mater(in %)</th>
                            <th rowSpan="2">Other Food Grains(in %)</th>
                            <th rowSpan="2">FAQ/Below FAQ</th>
                            <th rowSpan="2">Action Initiated</th>
                            <th rowSpan="2">Remarks</th>
                            <th rowSpan="2">Final Decision Taken</th>
                            <th rowSpan="2">Final Remarks</th>

                        </tr>
                        {/* <tr>
                            <th>PHH Qty.</th>
                            <th>AAY Qty.</th>
                            <th>PHH Qty.</th>
                            <th>AAY Qty.</th>
                            <th>Rice</th>
                            <th>Wheat</th>
                            <th>Rice</th>
                            <th>Wheat</th>
                        </tr> */}
                    </thead>
                    {showTable && (
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan="18" style={{ textAlign: 'center' }}>
                                        Loading...
                                    </td>
                                </tr>
                            ) : stockData.length > 0 ? (
                                stockData.map((entry, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{capitalizeFirstLetter(entry.districtName)}</td>
                                        <td>{capitalizeFirstLetter(entry.subDivisionName)}</td>
                                        <td>{capitalizeWords(entry.officerName)}</td>
                                        <td>
                                            {entry.dateOfInspection
                                                ? new Date(entry.dateOfInspection).toLocaleDateString("en-GB").replace(/\//g, "-")
                                                : "-"}
                                        </td>
                                        <td>{entry.godownName || "-"}</td>

                                        {/* Stock Differences */}
                                        <td>{entry.stockDifferenceRice && parseFloat(entry.stockDifferenceRice) !== 0 ? parseFloat(entry.stockDifferenceRice).toFixed(3) : "-"}</td>
                                        <td>{entry.typeOfStockDifferenceRice && entry.typeOfStockDifferenceRice !== "No Difference"
                                            ? entry.typeOfStockDifferenceRice
                                            : "-"}</td>
                                        <td>{entry.differenceWheat && parseFloat(entry.differenceWheat) !== 0 ? parseFloat(entry.differenceWheat).toFixed(3) : "-"}</td>

                                        <td>{entry.typeOfStockDifferencewheat && entry.typeOfStockDifferencewheat !== "No Difference"
                                            ? entry.typeOfStockDifferencewheat
                                            : "-"}</td>
                                        {/* Quality & Registers */}
                                        <td>{entry.badQuality === "NO" ? "-" : capitalizeWords(entry.badQuality || "N/A")}</td>
                                        <td>
                                            {entry.inwardRegisterUpdated === "NO" ||
                                                entry.outwardRegisterUpdated === "NO" ||
                                                entry.stockRegisterUpdated === "NO"
                                                ? "No"
                                                : ""}
                                        </td>                                        <td>{(entry.godownClosed === "NO" || entry.godownClosed === "Unknown") ? "-" : capitalizeWords(entry.godownClosed || "N/A")}</td>

                                        {/* Action */}
                                        <td>{actionLabels[entry.actionInitiated] || "-"}</td>
                                        <td>{entry.actionRemarks || "-"}</td>

                                        {/* Final Decision */}
                                        <td>
                                            <select
                                                value={(entry.actionTaken || "").trim()}
                                                onChange={(e) => handleDropdownChange(entry.godownId, "actionTaken", e.target.value)}
                                            >
                                                <option value="" disabled>Select Decision</option>
                                                <option value="revoke">Show cause Revoked</option>
                                                <option value="agm-suspended">AGM Suspended</option>
                                                <option value="qc-suspended">QC Suspended</option>
                                                <option value="agm-qc-suspended">AGM and QC suspended</option>
                                                <option value="salary-hold">Salary with Hold</option>
                                                <option value="other">Any other action</option>
                                            </select>
                                        </td>

                                        {/* <td>
                                            <input
                                                type="text"
                                                value={entry.finalRemarks || ""}
                                                onChange={(e) =>
                                                    handleDropdownChange(entry.godownId, "finalRemarks", e.target.value)
                                                }
                                            />
                                        </td> */}

                                        <td>
                                            <input
                                                type="text"
                                                value={entry.finalRemarks || ""}
                                                onChange={(e) => {
                                                    handleDropdownChange(entry.godownId, "finalRemarks", e.target.value);
                                                    if (finalErrors[index]) {
                                                        setFinalErrors((prev) => {
                                                            const updated = { ...prev };
                                                            delete updated[index];
                                                            return updated;
                                                        });
                                                    }
                                                }}
                                                className={finalErrors[index] ? "input-error" : ""}
                                                placeholder={
                                                    entry.actionTaken === "other"
                                                        ? "Enter final remarks (required)"
                                                        : "Final remarks (optional)"
                                                }
                                            />
                                            {/* {finalErrors[index] && (
                                                <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                                                    {finalErrors[index]}
                                                </div>
                                            )} */}
                                        </td>
                                    </tr>

                                ))

                            ) : (
                                <tr>
                                    <td colSpan="18" style={{ textAlign: 'center', color: 'red' }}>
                                        No Data Available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    )}
                </table>

            </div>






        </div>
    );
};

export default QcTPDSWhATRUpdate;